export default __webpack_public_path__ + "static/media/likeColored.95357615.svg";